import { createRoot } from "react-dom/client";

import { AutomationsApp } from "./automations-app";
import "@xyflow/react/dist/style.css";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("Automations root element is missing.");

createRoot(root).render(<AutomationsApp />);
